// extracted by mini-css-extract-plugin
export default {"wrapper":"s1k9rLco9v","container":"CDeNSTOppF","dark":"bNKxwaDxTA"};